export default __webpack_public_path__ + "static/media/campusmap_final.46af8d8c.png";